<h2>{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.ADD_SERVICE_RECORD' | translate }}</h2>
@if (formError) {
<div class="lin-form-error">{{ formError }}</div>
}
<form [formGroup]="form" (ngSubmit)="submitForm()">
  <lin-form-label required>{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.SERVICE_DATE' | translate }}</lin-form-label>

  <lin-datepicker-field formControlName="date" [isPlaceholderShown]="true"></lin-datepicker-field>

  <lin-form-label [required]="mileageRequired">
    {{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.MILEAGE' | translate: { value: (mileage | distance | number: '1.0-2') || 0 } }}
  </lin-form-label>
  <mat-form-field>
    <input matInput formControlName="odometer" autocomplete="off" />
    <mat-error>
      <lin-form-field-error [control]="form.get('odometer')" controlName="odometer"></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-label [required]="engineHoursRequired">
    {{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.ENGINE_HOURS' | translate: { value: (engineHours | duration | number: '1.0-2') || 0 } }}
  </lin-form-label>
  <mat-form-field>
    <input matInput formControlName="engineHours" autocomplete="off" />
    <mat-error>
      <lin-form-field-error></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <lin-form-label>{{ 'FIELDS.NOTE' | translate }}</lin-form-label>
  <mat-form-field>
    <textarea class="textarea" matInput rows="7" formControlName="note"></textarea>
  </mat-form-field>

  <lin-form-label [currencyLabel]="true">{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.COST' | translate }}</lin-form-label>
  <mat-form-field>
    <input formControlName="cost" matInput type="number" min="0" autocomplete="off" />
  </mat-form-field>

  <lin-form-file-picker formControlName="files" [uploadsPossible]="areUploadsPossible()">
    @if (record) { @for (file of record.files; track file.id) { @if (!form.get('removeFiles').value.includes(file.id)) {
    <lin-form-file-row name="{{ file.displayName }}" url="{{ file.path + file.name }}" (delete)="removeFile(file.id)"></lin-form-file-row>
    } } }
  </lin-form-file-picker>
  @if (form.controls.files.errors?.server) {
  <mat-error>{{ form.controls.files.errors.server }}</mat-error>
  }

  <lin-form-submit-button [isLoading]="isSubmitting" [isDisabled]="disabled" class="submit-button"
    >{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.SERVICE_DONE' | translate }}</lin-form-submit-button
  >
</form>
